import { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";

export default function OfflineBanner() {
  const [off, setOff] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  useEffect(() => {
    const on = () => setOff(false);
    const down = () => setOff(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", down); };
  }, []);
  if (!off) return null;
  return (
    <div data-testid="offline-banner" className="sticky top-0 z-[60] flex items-center justify-center gap-2 bg-[#FFB020] text-black text-sm font-medium py-2 px-4 text-center">
      <CloudOff className="w-4 h-4 shrink-0" /> Mode hors ligne — vos données sont enregistrées sur l'appareil et seront synchronisées automatiquement dès le retour du réseau.
    </div>
  );
}
